export default "__VITE_ASSET__DzZcH29a__"